import React from 'react'
import g from 'glamorous'
import { Card, Button } from 'antd'
import { ContentWrapper } from '../../shared/styles'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../shared/constants'
import Joyride from "react-joyride";
import { NavMenu } from "./NavMenu";
import { Header } from "./Header/index";

const add_button = { outline: '0', display: 'inline-block', marginBottom: '0', fontWeight: '500', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1', padding: '2 15px', fontSize: '12px', borderRadius: '5px', height: '33px', mozUserSelect: 'none', position: 'relative', color: '#000000a6', backgroundColor: '#09537C', borderColor: '#d9d9d9',color : "white",alignItems: 'center'};

const Content = g(ContentWrapper)({
  margin: '20px 20px',
})

class SelectCompanyError extends React.Component {
    state = {
    run: false
  };

  static defaultProps = {
    joyride: {}
  };

  handleClickStart = e => {
    e.preventDefault();

    this.setState({
      run: true
    });
  };

  handleJoyrideCallback = data => {
    const { joyride } = this.props;
    const { type } = data;

    if (typeof joyride.callback === "function") {
      joyride.callback(data);
    } else {
      console.group(type);
      console.log(data);
      console.groupEnd();
    }
  };
  render() {
    const { run } = this.state;

    return (
  <Content>
    <Card title="Welcome to TaxRecon" extra={
           <Button style={add_button}>
           <Link to={ROUTES.COMPANY_ADD}><span style={{display:"table-caption"}}>Add Company</span></Link>
         </Button>
        }>
      <p>
        Please select your company from dropdown at top of this page.
      </p>
    </Card>
    <br />
    <br />
    <Button onClick={this.handleClickStart}>Click here for a guided tour of TaxRecon Platform!</Button>
    <Joyride
          continuous
          scrollToFirstStep
          showProgress
          showSkipButton
          run={run}
          steps={[
            {
              content: "Thanks for choosing Taxrecon",
              placement: "center",
              disableBeacon: true,
              styles: {
                options: {
                  zIndex: 10000,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D !important',
                },
                title:{
                  fontFamily:'Roboto',
                  fontSize:'20px',
                  fontWeight:'bold'
                }
              },
              target: "body",
              title: "Let's start the tour!",
              skipButtonColor:'#C94D4D',
            },
            {
              content: "Here you can add a number of companies for which GST compliance is needed.",
              placement: "bottom",
              styles: {
                options: {
                  width: 460,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D',
                },
                title:{
                  fontFamily:'Roboto'
                }
              },
              target: ".tour_company",
              title: "Adding a Company"
            },
            {
              content: "Select the company which you want to work with.",
              placement: "bottom",
              styles: {
                options: {
                  width: 460,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D',
                },
                title:{
                  fontFamily:'Roboto'
                }
              },
              target: ".tour_select_company",
              title: "Selecting a Company"
            },
            {
              content: "Upload Sales Invoices using the Excel template provided.",
              placement: "bottom",
              styles: {
                options: {
                  width: 460,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D',
                },
                title:{
                  fontFamily:'Roboto'
                }
              },
              target: ".tour_upload_sales",
              title: "Sales Invoices Upload"
            },
            // {
            //   content: "After Sales Upload, view Regular Invoices here.",
            //   placement: "bottom",
            //   styles: {
            //     options: {
            //       width: 700
            //     }
            //   },
            //   target: ".tour_sales_regular",
            //   title: "View Regular Invoices"
            // },
            // {
            //   content: "After Sales Upload, view Amended Invoices here.",
            //   placement: "bottom",
            //   styles: {
            //     options: {
            //       width: 700
            //     }
            //   },
            //   target: ".tour_sales_amended",
            //   title: "View Amended Invoices"
            // },
            // {
            //   content: "Upload Purchase Invoices, similar to Sales Invoices.",
            //   placement: "bottom",
            //   styles: {
            //     options: {
            //       width: 700
            //     }
            //   },
            //   target: ".sub-menu-iteam",
            //   title: "Purchase Invoices Upload"
            // },
            // {
            //   content: "After Sales Upload, preview summary and export to GST network from here.",
            //   placement: "bottom",
            //   styles: {
            //     options: {
            //       width: 700
            //     }
            //   },
            //   target: ".tour_gstr1",
            //   title: "GSTR-1 Filing"
            // },
            // {
            //   content: "Here you can upload GSTR3B data and export to GST network.",
            //   placement: "bottom",
            //   styles: {
            //     options: {
            //       width: 700
            //     }
            //   },
            //   target: ".tour_gstr3b",
            //   title: "GSTR-3B Filing"
            // },
            // {
            //   content: "State-of-the-art SMART Reconciliation powered by ThoughtAI",
            //   placement: "bottom",
            //   styles: {
            //     options: {
            //       width: 700
            //     }
            //   },
            //   target: ".recon",
            //   title: "S.M.A.R.T RECON"
            // },
            {
              content: "Here you can see ITC Report (GSTR-3B Monthly Report vs GSTR-2A Monthly Report).",
              placement: "bottom",
              styles: {
                options: {
                  width: 460,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D',
                },
                title:{
                  fontFamily:'Roboto'
                }
              },
              target: ".itccorner",
              title: "ITC Corner"
            },
            {
              content: "See filing trends, Also view Sales/Purchases done w.r.t a particular GSTN!",
              placement: "bottom",
              styles: {
                options: {
                  width: 460,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D',
                },
                title:{
                  fontFamily:'Roboto'
                }
              },
              target: ".sft",
              title: "Return Filing Trends"
            },
            {
              content: "GST filings are no longer a hustle! Start filing with ease!",
              placement: "bottom",
              styles: {
                options: {
                  width: 460,
                  primaryColor:'#C94D4D',
                  skipButtonColor:'#C94D4D',
                },
                title:{
                  fontFamily:'Roboto'
                }
              },
              target: "body",
              title: "Happy Filing :)"
            }
          ]}
          callback={this.handleJoyrideCallback}
        />
  </Content>
)}

}

export default SelectCompanyError
